import { InternalAxiosRequestConfig, AxiosResponse } from 'axios'
import { useAuthStore } from 'Store/Auth'

export function setupAxios(axios: any) {
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_API_URL
  axios.defaults.headers.Accept = 'application/json'

  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const accessToken = useAuthStore.getState().accessToken
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }
      return config
    },
    async (error: any) => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    async (error: any) => {
      if (error.response.status === 401 && !error.config._retry) {
        // const refreshToken = useAuthStore.getState().refreshToken
        // const originalRequest = error.config

        // if (refreshToken) {
        // 	const { data, status } = await AuthRefreshToken(refreshToken)
        // 	const { accessToken, newRefreshToken } = data

        // 	if (status === 200) {
        // 		useAuthStore.setState({
        // 			accessToken: access_token,
        // 			refreshToken: refresh_token,
        // 		})
        // 		axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token
        // 		return AxiosInstance(originalRequest)
        // 	} else {
        // 		useAuthStore.setState({
        // 			profile: null,
        // 			accessToken: null,
        // 			refreshToken: null,
        // 		})

        // 		return Promise.reject(error)
        // 	}
        // } else {
        useAuthStore.getState().removeAccessToken()
        useAuthStore.getState().removeRefreshToken()

        return Promise.reject(error)
        // }
      }

      return Promise.reject(error)
    }
  )
}
